import dictionary from '@/utils/dictionary.json';
export const getAllDictionary = () => dictionary;
export const getDictionaryEntry = (language) => {
    return dictionary[language];
};
